<template>
  <div id="home">
    <emojis />
    <section
      id="section_I"
      class="flex j-c-center show-desktop"
      :style="{
        backgroundImage: 'url(' + require('@/assets/home/bg-sect-1.png') + ')',
      }"
    >
      <h1 class="animated bounceInDown">
        <span class="h1 f-w-700">A solução do</span>
        <span class="h1 f-w-700">seu dia a dia.</span>
      </h1>
    </section>

    <section id="section_I" class="show-mobile relative">
      <div class="text-center">
        <div class="absolute">
          <h1 class="show-mobile">A solução do seu dia a dia.</h1>
        </div>
        <img
          class="img-responsive"
          src="@/assets/home/bg-sect-1-mobile.png"
          alt=""
        />
      </div>
    </section>

    <section
      id="section_II"
      class="relative"
      :style="{
        backgroundImage: 'url(' + require('@/assets/home/bg-sect-2.png') + ')',
      }"
    >
      <!-- <div class="balcony flex j-c-center absolute show-mobile">
                <img class="img-responsive" src="@/assets/home/balcao-home.png" alt="balcao-home.png">
            </div> -->
      <div class="container section-II">
        <div class="row">
          <div class="col-md-6 whos positions">
            <h2 class="toUpperCase f-w-700 color-orange show-desktop">
              o que é a <br />
              ponto fácil?
            </h2>
            <h2
              class="toUpperCase medi-tittle f-w-700 color-orange show-mobile"
            >
              o que é a ponto fácil
            </h2>
            <h2
              class="color-white edited-mobile f-w-700 mt-3 big-title text-uppercase"
              style="font-size: 38px"
            >
              A primeira franquia de serviços públicos e privados do Brasil
            </h2>
            <h2
              class="color-white edited-mobile f-w-700 mt-3 big-title text-uppercase"
              style="font-size: 38px"
            ></h2>
            <img
              class="img-responsive brushstroke"
              src="@/assets/home/brushstroke.png"
            />
            <!-- <div class="balcony show-desktop">
                            <div>
                                <img class="img-responsive" src="@/assets/home/balcao-home.png" alt="balcao-home.png">
                            </div>
                        </div> -->
          </div>
          <div class="col-md-6">
            <p class="toDescriptions">
              Oferecemos mais de <strong>1.000 serviços digitais</strong> em um
              só lugar! <br />
              <br />
              Você pode encontrar nossas franquias por todo o Brasil. <br />
              Nós já estamos nas lotéricas, correios, supermercados, shoppings,
              aeroportos, escolas, faculdades e lojas em centros comerciais.
            </p>
            <h2
              class="toUpperCase color-orange title-between little-title f-w-700"
              style="font-size: 24px"
            >
              o mundo é cada vez mais digital
              <img
                src="@/assets/home/laptop.png"
                class="ico-laptop img-responsive"
              />
            </h2>
            <p class="toDescriptions">
              As pessoas estão sofrendo com a falta de conhecimento em
              tecnologia e excesso de burocracias.
            </p>
            <h2
              class="toUpperCase color-orange title-between little-title f-w-700"
              style="font-size: 24px; line-height: 30px !important"
            >
              "Quem nunca desistiu de fazer um cadastro na internet por que era
              muito grande e chato?”
            </h2>
            <p class="toDescriptions">
              Para resolver esse e centenas de outros problemas criamos uma
              solução totalmente inovadora!
            </p>
          </div>
        </div>
      </div>
    </section>
    <section
      id="section_III"
      class="show-desktop"
      :style="{
        backgroundImage: 'url(' + require('@/assets/home/bg-sect-3.png') + ')',
      }"
    >
      <div class="container section-III">
        <h2 class="big-title color-white f-w-700">
          Mais de 400 <br />
          serviços à sua <br />
          disposição
        </h2>
        <div class="someWorksAvailable flex flex-wrap relative">
          <div
            class="flex j-c-center someWorksAvailableDIV"
            v-for="(item, index) in worksAvailabel"
            :key="index"
          >
            <h4 class="text-center f-w-700">{{ item }}</h4>
          </div>
          <a
            href=""
            v-scroll-to="'#section_VI'"
            class="absolute knowMoreWorks flex j-c-center"
          >
            <div><span>Ver mais serviços</span></div>

            <div class="icon-download">
              <img
                class="img-responsive"
                src="@/assets/home/icon-download.png"
                alt="icon-download"
              />
            </div>
          </a>
        </div>
      </div>
    </section>

    <section id="section_III" class="show-mobile relative">
      <div>
        <img
          class="img-responsive"
          src="@/assets/home/bg-sect-3-mobile.png"
          alt="bg-sect-3-mobile"
        />
      </div>
      <div class="container section_III absolute content">
        <h3 class="little-title color-white toUpperCase f-w-700">
          alguns de nossos serviços
        </h3>
        <h2 class="big-title color-white f-w-700">
          Mais de 1.000 serviços à sua disposição
        </h2>
      </div>
      <div class="absolute someWorksAvailable carousel-mobile flex j-c-center">
        <VueSlickCarousel
          v-bind="settings"
          class="text-center someWorksAvailableDIV"
        >
          <div
            class="flex divSomeWorksInMobile j-c-center"
            v-for="(item, index) in worksAvailabel"
            :key="index"
          >
            <h4 class="text-center toUpperCase f-w-700">{{ item }}</h4>
          </div>
        </VueSlickCarousel>
      </div>
      <div class="text-center seeMore">
        <a
          href=""
          v-scroll-to="'#section_VI'"
          class="absolute knowMoreWorks flex"
        >
          <div><span>Ver mais serviços</span></div>

          <div class="icon-download">
            <img
              class="img-responsive"
              src="@/assets/home/icon-download.png"
              alt="icon-download"
            />
          </div>
        </a>
      </div>
    </section>

    <section id="section_VI">
      <div class="section-VI">
        <other-services />
      </div>
    </section>

    <section id="section_IV">
      <div
        :style="{
          backgroundImage:
            'linear-gradient(to right, rgba(0,0,0,0.2) 0%,rgba(0,0,0,0.7) 100%), url(' +
            require('@/assets/home/bg-sect-4.png') +
            ')',
        }"
      >
        <media-play
          :title="'Por que a vida pode ser mais simples. Quem já conhece aprova!'"
          :linkVideo="'https://www.youtube.com/embed/b-14e4o12oI'"
        />
      </div>
    </section>

    <section>
      <div id="section_V" class="section-V">
        <ponto-nearby-u />
      </div>
    </section>

    <section id="section_VII">
      <wanna-be-franchisee />
    </section>

    <section id="section_VIII">
      <learned />
    </section>
  </div>
</template>

<style scoped>
@media (min-width: 799px) {
  .positions {
    position: relative;
    top: 56px;
  }
}
.ico-laptop {
  width: 50px;
}
#section_I {
  height: 100vh;
  width: 100vw;
  background-attachment: fixed;
  background-size: cover;
}

#section_II {
  height: 172vh;
  background-size: cover;
  background-repeat: no-repeat;
  margin-bottom: 200px;
  margin-top: -120px;
  position: relative;
  z-index: 2;
}

.section-II {
  padding-top: 250px;
}

h1 {
  margin-top: -100px;
  font-size: 65px;
  color: #fff;
  font-weight: 700;
}

h1 :nth-child(1) {
  margin-left: -30px;
  padding-right: 200px;
}

h1 :nth-child(2) {
  padding-left: 100px;
}

.brushstroke {
  width: 700px;
  z-index: -10;
  top: -280px;
  position: relative;
  left: -200px;
}

.balcony img {
  width: 80%;
  position: absolute;
  margin-top: -370px;
  margin-left: -50px;
}

.whos :nth-child(1) {
  font-size: 30px;
}

.whos :nth-child(2) {
  line-height: 1;
}

p {
  color: #fff;
  text-align: left;
}

.title-between {
  margin: 35px 0;
}

#section_III {
  background-size: cover;
  background-attachment: fixed;
  margin-top: -400px;
  padding-bottom: 80px;
  position: relative;
}

.section-III {
  padding-top: 250px;
}

.someWorksAvailable {
  width: 50%;
  padding: 25px 0 50px 0;
}

.someWorksAvailable h4 {
  font-size: 15px;
  color: #2474b2;
  margin: 0;
  padding: 0 20px;
}

.someWorksAvailableDIV {
  margin: 0 10px 10px 0;
  min-width: 35%;
  max-width: 35%;
  min-height: 85px;
  border-radius: 15px;
  background-color: #fff;
}

.knowMoreWorks {
  bottom: 0;
  right: 28%;
}

.knowMoreWorks span {
  font-size: 18px;
}

#section_III a {
  color: #fff;
  font-size: 15px;
  font-weight: 700;
}

#section_III a:hover {
  text-decoration: none;
}

#section_III .icon-download img {
  width: 25px;
  margin-left: 10px;
}

#section_IV > div {
  background-attachment: initial;
  background-position: center;
  position: relative;
  width: 100vw;
}

.no-padding {
  padding: 0 10px !important;
}

@media only screen and (max-width: 1920px) {
  .h1 {
    font-size: 60px !important;
  }

  h1 {
    margin-top: -100px;
  }

  h1 :nth-child(2) {
    padding-left: 200px;
  }
}

@media only screen and (max-width: 1600px) {
  .h1 {
    font-size: 60px !important;
  }
  h1 {
    margin-top: -150px !important;
  }

  h1 :nth-child(1) {
    margin-left: 0px;
    padding-right: 100px;
  }
}

@media only screen and (max-width: 1366px) {
  h1 {
    margin-top: -250px;
  }

  .h1 {
    font-size: 60px !important;
  }

  h1 :nth-child(2) {
    padding-left: 150px;
  }

  #section_I {
    background-position: top;
  }

  #section_II {
    margin-top: -125px;
    background-position: center;
  }

  .section-III {
    padding-top: 400px;
  }
}

@media only screen and (max-width: 1024px) {
  .h1 {
    font-size: 50px !important;
  }

  h1 :nth-child(2) {
    padding-left: 50px;
  }

  #section_I,
  #section_III {
    background-position: center;
  }

  .notebook {
    right: -175px;
  }
}

@media only screen and (max-width: 992px) {
  #section_I {
    background-position: center;
  }

  span {
    margin: 0 !important;
    padding: 5px !important;
  }

  .h1 {
    font-size: 50px !important;
  }

  #section_II {
    margin-top: -200px !important;
  }

  #section_III {
    background-position: -500px;
  }
  #section_II {
    margin-top: -300px !important;
    height: 130vh !important;
  }
  /* h1 :nth-child(1){
            margin-right: 50px!important;
        } */
  .someWorksAvailable {
    width: 75%;
  }
}

@media only screen and (max-width: 767px) {
  h1 {
    font-size: 45px;
    padding: 0 15px;
    margin-top: 125px !important;
  }

  .animated {
    width: 100%;
  }

  .balcony {
    width: 100%;
    position: absolute;
    top: -100px;
    right: -15%;
  }

  .balcony img {
    width: 250px;
    margin-top: 250px;
  }

  #section_II {
    margin-top: -80px;
    width: 100vw;
    background-position: center;
    padding-bottom: 200px;
    padding-left: 25px;
    height: auto;
    margin-top: -100px !important;
  }

  .whos {
    height: 250px;
  }

  p.toDescriptions {
    width: 90% !important;
    text-align: left;
  }

  .section_III {
    padding: 165px 0 0 40px;
  }

  #section_III {
    margin-top: -400px;
    padding-bottom: 0;
  }

  .section_III h2:nth-child(2) {
    margin-top: 20px;
  }

  .carousel-mobile {
    bottom: 10%;
  }

  div >>> .text-center.slick-slider.slick-initialized {
    width: 100vw;
  }

  .someWorksAvailable {
    width: 100%;
    padding: 50px 0;
  }

  .someWorksAvailableDIV {
    margin: 0 10px 10px 10px;
    min-width: 80%;
    max-width: 80%;
    min-height: 85px;
    border-radius: 15px;
    background-color: #fff;
  }

  .divSomeWorksInMobile h4 {
    font-size: 16px;
    padding: 40px 20px 25px 20px;
  }

  .seeMore {
    position: absolute;
    height: 50px;
    width: 110%;
    bottom: 7%;
  }

  #section_V {
    overflow: hidden;
  }
}

@media only screen and (max-width: 420px) {
  #section_II {
    margin-top: -200px !important;
    height: 228vh !important;
  }
}
#section_III {
  margin-top: -440px;
  padding-bottom: 0;
}

@media only screen and (max-width: 375px) {
  #section_I {
    height: 120vh;
  }
  #section_II {
    margin-top: -150px !important;
    height: 260vh !important;
  }
}
@media only screen and (max-width: 330px) {
  #section_I {
    height: 140vh;
  }
  #section_II {
    margin-top: -130px !important;
    height: 370vh !important;
  }
  .content {
    padding-top: 100px;
  }
}
</style>

<script>
// import $ from 'jquery'
import OtherServices from "@/components/OtherServices.vue?v=4";
import WannaBeFranchisee from "@/components/WannaBeFranchisee.vue?v=4";
import Learned from "@/components/Learned.vue?v=4";
import PontoNearbyU from "@/components/PontoNearbyU.vue?v=4";
import MediaPlay from "@/components/MediaPlay.vue?v=4";
import Emojis from "@/components/Emojis.vue?v=4";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";

export default {
  data() {
    return {
      worksAvailabel: [
        "Segunda via de boletos, contas e faturas",
        "Agendamentos",
      ],
      settings: {
        dots: false,
        infinite: true,
        autoplay: true,
        autoplaySpeed: 1500,
        slidesToShow: 5,
        slidesToScroll: 1,
        initialSlide: 0,
        arrows: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
              infinite: true,
            },
          },
        ],
      },
    };
  },

  components: {
    OtherServices,
    WannaBeFranchisee,
    Learned,
    PontoNearbyU,
    MediaPlay,
    Emojis,
    VueSlickCarousel,
  },
  mounted() {
    this.$ga.page("/");
  },
  methods: {},
};
</script>
